import i18next from 'i18next';

const getFooterLinks = () => [
    {
        link: 'https://www.discoveryeducation.com/legal/terms/career-connect/',
        target: '_blank',
        routerLink: false,
        text: i18next.t('Terms of Use'),
    },
    {
        link: 'https://www.discoveryeducation.com/legal/privacy/career-connect/',
        target: '_blank',
        routerLink: false,
        text: i18next.t('Privacy Policy'),
    },
    {
        link: 'https://www.discoveryeducation.com/who-we-are/about-discovery-education.cfm',
        target: '_blank',
        routerLink: false,
        text: i18next.t('About Us'),
    },
];

export { getFooterLinks };
